import {cdnImage} from '@/util/cdnImage';
import {MUIContainer} from '@/components/MUI-Components';
import {STO_DEVELOPMENT_COMPANY} from '@/util/metaData/crypto';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';
import React from 'react';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        stoDevelopmentBannerBottom,
        stoDevelopmentChooseBody,
        stoDevelopmentChooseContent,
        stoDevelopmentDecoding,
        STODevelopmentFAQ,
        stoDevelopmentLeader,
        stoDevelopmentServices,
        stoDevelopmentSuccess,
        stoDevelopmentTable,
        stoDevelopmentTechnologyData,
        stoMobileProcess,
        stoTokenDevelopment
    } = await import('@/util/contents/sto-development');

    const {econophyCheckPoint} = await import('@/util/contents/real-world-data');

    const {alfaminBody} = await import('@/util/contents/real-estate-tokenization');

    return {
        props: {
            stoDevelopmentBannerBottom,
            stoDevelopmentChooseBody,
            stoDevelopmentChooseContent,
            stoDevelopmentDecoding,
            STODevelopmentFAQ,
            stoDevelopmentLeader,
            stoDevelopmentServices,
            stoDevelopmentSuccess,
            stoDevelopmentTable,
            stoDevelopmentTechnologyData,
            stoMobileProcess,
            stoTokenDevelopment,
            econophyCheckPoint,
            alfaminBody
        }
    };
};

const Banner = dynamic(() => import('@/components/Ui-components/Banner'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const Decoding = dynamic(() => import('@/components/Ui-components/Decoding'));
const auditImg = cdnImage('STO-Development-Company/Security-Token-Offering.webp');
const TableBlockchain = dynamic(() => import('@/components/Ui-components/tableBlockchain'));
const HelperSection = dynamic(() => import('@/components/Ui-components/helper-section'));
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
const Platforms = dynamic(() => import('@/components/Ui-components/platforms'));
const IndustryLeaders = dynamic(import('@/components/Ui-components/IndustryLeaders'));
const TokenizeHelp = dynamic(import('@/components/Ui-components/tokenize-help'));
const CardTechnology = dynamic(() => import('@/components/Ui-components/card-technology'));
const MobileProcess = dynamic(() => import('@/components/Ui-components/MobileProcess'));
const development = cdnImage('STO-Development-Company/STO-Development-Process.svg');
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));
const LetsDiscuss = dynamic(() => import('@/components/Ui-components/Lets-discuss'));
const Questions = dynamic(() => import('@/components/Ui-components/questions'));
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const llcGroup = cdnImage('Asset-tokenization/Econophy-Group.webp');
const alfahimImg = cdnImage('real-estate-tokenization/AlFahim Group.webp');
import AggregateScript from '@/components/Common/Aggregate-script';
import {CDN_URL, SITE_URL} from '@/constants/urls';

// Migrated from globals.scss `.tokenization-help-header-wrapper` (sole consumer — this page only).
const tokenizationHelpHeaderWrapperSx = {textAlign: 'left !important'} as const;

const STODevelopment = (props: any) => {
    const {
        openForm,
        stoDevelopmentBannerBottom,
        stoDevelopmentChooseBody,
        stoDevelopmentChooseContent,
        stoDevelopmentDecoding,
        STODevelopmentFAQ,
        stoDevelopmentLeader,
        stoDevelopmentServices,
        stoDevelopmentSuccess,
        stoDevelopmentTable,
        stoDevelopmentTechnologyData,
        stoMobileProcess,
        stoTokenDevelopment,
        econophyCheckPoint,
        alfaminBody
    } = props;

    const alfahimData = [
        'AlFahim Group, a premier real estate firm in Dubai, sought to streamline their property management and enable seamless fractional ownership. They aimed to modernize their operations and significantly reduce the paperwork for over 7,000 property units. Debut Infotech, a <a target="_blank" href="/real-estate-tokenization">real estate tokenization development company</a> developed an advanced blockchain-based tokenization platform to fulfill these goals.'
    ];

    const llcData = [
        'The Econophy Group LLC, a leading pharmaceutical company, aimed to tokenize their biotech patents to accelerate the development of non-invasive nuclear medicine and molecular imaging (NMMI) diagnostic technology. The objective was to modernize asset management and offer fractional ownership through secure, blockchain-based tokenization.'
    ];
    return (
        <Box>
            <PageHead meta={STO_DEVELOPMENT_COMPANY} url="/security-token-offerings-sto-development-company" />
            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="STO Development Company"
                subheading="Raise capital without roadblocks using our STO development services. We assist businesses digitize assets, tokenize equity, real estate, and commodities, and create a liquid, investor-friendly ecosystem. Our regulatory-first approach integrates smart contracts, automated compliance, and investor protection, ensuring a smooth and transparent capital-raising process."
                image={cdnImage('STO-Development-Company/STO-Development-Company.webp')}
                // bannerBackground="bitcoin-wallet-banner-background"
                bannerClass="multicurrency-development-banner"
                alt="STO Development Company"
                button="Request a Quote"
            />
            <Box className="sub-banner-wrapper sub-banner-bottom-wrapper">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Our Strategic Partners</Typography>
                        </Grid>
                        {stoDevelopmentBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="bottom-margin top-space decording-main-wrapper mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Decoding
                        imageSrc={auditImg}
                        alt="What is Security Token Offering (STO)?"
                        heading="What is Security Token Offering (STO)?"
                        subHeading={stoDevelopmentDecoding}
                        isSocialMediaBtn={true}
                        className="sto-development-decoding-wrap"
                    />
                </MUIContainer>
            </Grid>
            <hr className="hr-line zero-margin" />
            <Box className="top-space bottom-spacing  mobile-top-padding mobile-bottom-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions ">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Difference Between STO (Security Token Offering) Vs ICO (Initial Coin Offering)
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left">
                                For businesses looking to raise funds securely, STOs offer legally compliant, asset-backed tokens with
                                investor protections, unlike ICOs. With stricter regulatory oversight, STOs ensure transparency and trust.
                                Below, we’ve made a comprehensive comparison between ICO vs. STO to guide your decision.
                            </Typography>
                        </Box>
                    </Box>
                    <TableBlockchain data={stoDevelopmentTable} defaultRow={true} />
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="helper-section helper_section_parent">
                <Box className=" bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                                Different Types of Security Tokens Designed for Fundraising Success
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line divider-line-left" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    Selecting the right security token model depends on your fundraising goals, investor expectations, and
                                    industry requirements. Whether you seek to raise funds through equity-backed STOs or token creation for
                                    asset ownership, ensuring regulatory oversight is key to a successful launch. Below are different types
                                    of security tokens that enterprises can develop for fundraising:
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={stoDevelopmentSuccess} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Planning to raise funds with a compliant and secure STO?"
                    subheading="Give your investors the assurance of protected returns with a fully compliant security token. Let’s strategize your security token offering for a successful fundraise."
                    buttonText="Book a Free Consultation"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid
                item
                xs={12}
                className="blockchain-revolution-service bottom-spacing mobile-top-padding mobile-bottom-padding top-space helper_section_parent"
            >
                <MUIContainer>
                    <Platforms
                        data={stoDevelopmentServices}
                        heading="Our End-to-End STO Development Services"
                        subheading="As a full-service STO development company, we provide a seamless approach to structuring, launching, and managing security token offerings that comply with global regulations."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12}>
                <Box className="renowed-client-wrapper top-space bottom-spacing mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <IndustryLeaders
                            heading="How Security Token Offerings Help Enterprises Scale Faster"
                            data={stoDevelopmentLeader}
                            className="industry-leader-content-wrapper industry-leader-content-animation"
                            classNm="industry-leader-content-side-space"
                        />
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="bottom-spacing mobile-bottom-padding">
                <LatestCTA
                    heading="Ready to raise funds with a security token backed by assets and investor trust?"
                    subheading="From fractionalized ownership to seamless capital deployment, STOs provide a structured, scalable way to grow. Let’s discuss the right STO strategy for your business."
                    buttonText="Talk to Our Experts"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing mobile-bottom-padding helper_section_parent top-space mobile-top-padding">
                <MUIContainer>
                    <TokenizeHelp heading="Explore the Asset Classes That Can Be Tokenized in an STO" contentData={stoTokenDevelopment} />
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="dynmaic-white-label-wrapper top-space bottom-margin mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Box
                        className="spectrum-header-wrapper solutions tokenization-help-header-wrapper"
                        sx={tokenizationHelpHeaderWrapperSx}
                    >
                        <Typography className="spectrum-heading color-black " component="h2">
                            Spotlight on Our STO Development Projects
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                    </Box>
                    <DynamicScreens
                        imageSrc={llcGroup}
                        subHeading="The Econophy Group LLC"
                        heading="Tokenized Biotech Patents for Advanced Diagnostic Technology"
                        subPoints={llcData}
                        reverseOrder={true}
                        alt="The Econophy Group LLC"
                        checkItems={econophyCheckPoint}
                        openForm={openForm}
                        imageClass="techSpeak-dynamic-image"
                    />
                    <DynamicScreens
                        imageSrc={alfahimImg}
                        subHeading="AlFahim Group"
                        heading="Transforming Property Management with Real Estate Tokenization"
                        subPoints={alfahimData}
                        reverseOrder={false}
                        alt="AlFahim Group"
                        checkItems={alfaminBody}
                        openForm={openForm}
                    />
                </MUIContainer>
            </Grid>
            <Grid
                item
                xs={12}
                className=" generative-tech-wrapper helper_section_parent top-space bottom-spacing mobile-top-padding mobile-bottom-padding"
            >
                <CardTechnology
                    heading="Technologies We Employ to Engineer STO Solutions "
                    subheading="Our STO development firm employs cutting-edge blockchain technologies and security frameworks to deliver regulatory-compliant tokenization solutions. From smart contracts to investor management, our comprehensive tech stack supports seamless security token issuance, ensuring transparency, efficiency, and trust in digital asset fundraising."
                    data={stoDevelopmentTechnologyData}
                />
            </Grid>
            <Box className="bottom-spacing top-space mobile-top-padding process-mobile-bottom-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Our Comprehensive STO Development Roadmap for Seamless Fundraising
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left" component="p">
                                As a leading STO development firm, we follow a structured approach to develop secure, compliant, and
                                investor-friendly STO platforms. Our approach ensures smooth security token issuance, regulatory adherence,
                                and seamless fundraising tailored to your business needs.
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign="center">
                        <DisplayImage
                            src={development}
                            alt="Derivatives Exchange Development "
                            className="approach-main-img approach-web-img"
                        />
                    </Box>
                    <Box className="approach-main-img approach-mobile-img">
                        <MobileProcess mobileProcess={stoMobileProcess} />
                    </Box>
                </MUIContainer>
            </Box>
            <OurMakeChoice
                heading="Why Choose Debut Infotech"
                subheading="as Your Trusted Partner in STO Development?"
                body={stoDevelopmentChooseBody}
                contentData={stoDevelopmentChooseContent}
            />
            <Grid item xs={12} className="bottom-spacing">
                <LetsDiscuss
                    heading="Launch a Secure and Compliant STO Platform Today"
                    subheading="Let’s develop an STO solution that ensures regulatory compliance, enhances liquidity, and attracts institutional investors."
                    btnLabel="Contact Our STO Experts"
                    className="white-label-sprill"
                    openForm={() => {
                        globalThis.open('/contact-us', '_blank');
                    }}
                />
            </Grid>
            <Grid item xs={12} className="question-parent top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={STODevelopmentFAQ} subpart={true} />
                </MUIContainer>
            </Grid>
            <script
                type="application/ld+json"
                id="sto-development-company"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'What is a Security Token Offering (STO)?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'A Security Token Offering (STO) is a regulated fundraising method where digital security tokens represent equity, assets, or rights in a company. Unlike ICOs, STOs comply with financial regulations, ensuring investor protection and legal oversight.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How does a Security Token Offering (STO) work?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'A Security Token Offering (STO) works by issuing blockchain-based tokens that represent real-world assets like real estate, stocks, or bonds. These tokens are offered to investors in compliance with SEC, FINMA, and other regulatory bodies and can be traded on security token exchanges.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the difference between an STO and an ICO?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The key difference between an STO (Security Token Offering) and an ICO (Initial Coin Offering) is regulatory compliance. ICOs issue utility tokens with no legal backing, while security token offerings STO provide asset-backed, legally compliant digital securities.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What are the benefits of Security Token Offerings (STOs)?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `The benefits of security token offerings STO include:
Regulatory compliance for secure fundraising
Fractional ownership of high-value assets like real estate
Global investor participation with security token exchanges
Enhanced liquidity for traditionally illiquid assets
Automated compliance through smart contracts`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What assets can be tokenized in an STO?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `STOs can tokenize various assets, including:
Real Estate Security Token Offerings (Residential, Commercial, REITs)
Equity Shares & Private Equity
Debt Instruments (Bonds, Loans)
Intellectual Property & Royalties
Commodities (Gold, Oil, Art, Collectibles)`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How much does Security Token Offering development cost?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The cost of security token offering development depends on factors like tokenization complexity, compliance requirements, and platform development. On average, STO development costs range from $50,000 to $300,000, covering token issuance, investor management, and exchange integration.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What are the regulations for Security Token Offerings?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Security Token Offering regulation varies by country:
USA: Must comply with SEC regulations (Reg D, Reg S, Reg A+)
Europe: Governed by ESMA and MiFID II
Asia: Jurisdictions like Singapore have MAS-regulated STO frameworks`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do Security Token Offering development services work?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Security Token Offering development services include:
Token creation and issuance
Smart contract development for compliance
STO platform development
Investor KYC/AML integration
Exchange listing for security token liquidity`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the best Security Token Offering platform?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Top Security Token Offering platforms include:
Polymath (Tokenization for regulated securities)
Securitize (End-to-end STO solutions)
Tokeny (Compliant asset tokenization)`
                                }
                            }
                        ]
                    })
                }}
            />

            <AggregateScript
                name="STO Development"
                image={`${CDN_URL}?url=%2Fimages%2FSTO-Development-Company%2FSTO-Development-Company.webp&w=750&q=75`}
                description="Launch secure and compliant Security Token Offerings (STOs) with our end-to-end STO development services. From token creation to investor management, we provide scalable, regulatory-compliant solutions for fundraising, ensuring transparency, liquidity, and global reach for your digital assets."
                offers={{
                    '@type': 'AggregateOffer',
                    url: `${SITE_URL}/security-token-offerings-sto-development-company`,
                    priceCurrency: 'USD',
                    lowPrice: '50000',
                    highPrice: '300000',
                    offerCount: '4'
                }}
                aggregateRating={{
                    '@type': 'AggregateRating',
                    ratingValue: '4.8',
                    bestRating: '5',
                    worstRating: '2',
                    ratingCount: '399'
                }}
            />
        </Box>
    );
};

export default STODevelopment;
STODevelopment.Layout = 'Main';
